import React from 'react';
import { Phone, Calendar, Timer, ShieldCheck, Award, FileCheck, Wrench } from 'lucide-react';
import { company, features } from '../mock';

const iconMap = { Timer, ShieldCheck, Award, FileCheck, Wrench };

const Hero = () => {
  return (
    <section id="home" className="relative pt-24">
      <div className="relative h-[640px] md:h-[720px] hero-bg flex items-center justify-center overflow-hidden">
        {/* Water droplet decorative overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-navy/30 via-transparent to-brand-navy/40 pointer-events-none" />
        <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
          backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><circle cx=%2220%22 cy=%2230%22 r=%221%22 fill=%22white%22 opacity=%220.4%22/><circle cx=%2280%22 cy=%2260%22 r=%221.5%22 fill=%22white%22 opacity=%220.3%22/></svg>')",
          backgroundSize: '120px 120px'
        }} />

        <div className="relative z-10 max-w-5xl mx-auto px-4 text-center text-white fade-up">
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-wide">
            INTERVENTO PER<br />
            <span className="text-white">DANNI D&rsquo;ACQUA IN TICINO</span>
          </h1>
          <p className="mt-6 text-sm md:text-base lg:text-lg tracking-[0.25em] font-medium text-white/90">
            RICERCA PERDITE &nbsp;—&nbsp; RISANAMENTI &nbsp;—&nbsp; DEUMIDIFICAZIONI
          </p>

          <div className="mt-10 inline-flex flex-col items-center bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-8 py-5">
            <span className="text-xs uppercase tracking-widest text-white/80 mb-1">Chiamaci subito</span>
            <a href={`tel:${company.phoneRaw}`} className="flex items-center gap-3 text-2xl md:text-3xl font-display font-bold text-white hover:text-brand-red transition-colors">
              <Phone className="w-6 h-6 text-brand-red" />
              {company.phone}
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <a href={`tel:${company.phoneRaw}`} className="inline-flex items-center gap-2 bg-brand-red hover:bg-brand-red-dark text-white px-8 py-4 rounded-md font-bold uppercase tracking-wide text-sm transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5">
              <Phone className="w-4 h-4" />
              Emergenza
            </a>
            <a href="#contatti" className="inline-flex items-center gap-2 bg-brand-navy hover:bg-brand-navy-light text-white px-8 py-4 rounded-md font-bold uppercase tracking-wide text-sm transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5">
              <Calendar className="w-4 h-4" />
              Richiedi Sopralluogo
            </a>
          </div>
        </div>
      </div>

      {/* Features strip */}
      <div className="bg-gray-50 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
            {features.map((f) => {
              const Icon = iconMap[f.icon];
              return (
                <div key={f.title} className="flex flex-col items-center text-center group">
                  <div className="w-14 h-14 rounded-full bg-white border-2 border-brand-red flex items-center justify-center mb-3 group-hover:bg-brand-red transition-colors">
                    <Icon className="w-6 h-6 text-brand-red group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-display text-sm md:text-base font-bold text-brand-navy uppercase tracking-wide">{f.title}</h3>
                  <p className="text-xs md:text-sm text-gray-600 mt-1">{f.subtitle}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
